import SupplierInfoFields, { supplierDisplayName } from '../Fournisseur/SupplierInfoFields';
import PurchaseDiscount from '../shared/PurchaseDiscount';
import { validPurchaseQuantities } from '../../helpers/purchaseQuantities';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Table, Row, Col, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { receiptNoteActions } from '../../sagas/receiptNoteSlice';
import Swal from 'sweetalert2';
import { formatPrice } from '../../helpers/utility';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { components } from 'react-select';
import { supplierActions } from '../../sagas/supplierSlice';
import { FaArrowLeft, FaBuilding, FaBusinessTime, FaEnvelope, FaIdCard, FaMapMarkerAlt, FaMoneyBillWave, FaPhone, FaPlus, FaUser } from 'react-icons/fa';
import ReceptionLines from './ReceptionLines';
import { useLocation, useNavigate } from 'react-router-dom';
import { entrepotActions } from '../../sagas/entrepotSlice';
import { purchaseActions } from '../../sagas/purchaseSlice';
import '../shared/DocumentForm.css';
import './SimpleReception.css';
import './CompactPurchases.css';

const ReceiptNoteNew = ({ onClose, reception, initialValues, purchaseOrder }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const routeState = location.state || {};
    const activePurchaseOrder = purchaseOrder || routeState.purchaseOrder || null;
    const sourceReception = reception || initialValues || routeState.reception || routeState.initialValues || {};
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const { company } = useSelector(statut => statut.auth);
    const { purchases, loading } = useSelector((state) => state.purchases);
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const [errors, setErrors] = useState({});
    const closeForm = () => {
        if (onClose) {
            onClose();
            return;
        }

        navigate(routeState.returnTo || '/purchases-module/reception', {
            state: routeState.returnState,
        });
    };

    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: null,
        dateTo: null,
        query: ''
    });

    const villesMaroc = [
        'Casablanca', 'Rabat', 'Khouribga', 'Marrakech', 'Fès', 'Tanger',
        'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan',
        'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'
    ];

    const [fournisseur, setFournisseur] = useState({
        nom: '',
        prenom: '',
        cin: '',
        telephone1: '',
        telephone2: '',
        email: '',
        adresse: '',
        ville: 'Casablanca',
        typeFournisseur: 'PARTICULIER',
        codePostal: '',
        plafond: 0,
        entreprise: '', // New field for "Entreprise"
        ice: '',// New field for "ICE",
        active: true,
        solde: 0 // Ce champ sera en lecture seule
    });
    const { entrepots } = useSelector(state => state.entrepots);


    useEffect(() => {
        let payload = {
            ...filters,
            notReceptioned: true,
        };
        dispatch(purchaseActions.search(payload));

        dispatch(supplierActions.search({
            query: ""
        }));

    }, []);

    useEffect(() => {
    }, [suppliers, purchases])


    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    const poOptions = !loading ? (purchases || []).map(po => ({
        fournisseurId: po.fournisseurId,
        fournisseurNom: po.fournisseurNom,
        numeroCheque: po.numeroCheque,
        lignes: po.lignes,
        montantTotalHT: po.montantTotalHT,
        montantTotalAvantRemise: po.montantTotalAvantRemise || po.montantTotalTTC,
        montantRemise: po.montantRemise || 0,
        modeRemise: po.modeRemise,
        valeurRemise: po.valeurRemise,
        montantTotalTTC: po.montantTotalTTC,
        montantTotalTaxe: po.montantTotalTaxe,
        modeReglement: po.modeReglement,
        commandeId: po.id,
        value: po.numero,
        label: `${po.numero} - ${po.fournisseurNom}`
    })) : [];

    const formik = useFormik({
        initialValues: {
            fournisseurId: sourceReception.fournisseurId || null,
            fournisseurNom: sourceReception.fournisseurNom || '',
            deliveryNoteNb: sourceReception.deliveryNoteNb || '',
            dateReception: sourceReception.dateReception || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            dateOperation: sourceReception.dateOperation || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            lignes: sourceReception.lignes || [],
            montantTotalHT: sourceReception.montantTotalHT || 0,
            montantTotalAvantRemise: sourceReception.montantTotalAvantRemise ?? ((Number(sourceReception.montantTotalTTC) || 0) + (Number(sourceReception.montantRemise) || 0)),
            montantRemise: sourceReception.montantRemise || 0,
            modeRemise: sourceReception.modeRemise || 'MONTANT',
            valeurRemise: sourceReception.valeurRemise ?? sourceReception.montantRemise ?? 0,
            montantTotalTTC: sourceReception.montantTotalTTC || 0,
            montantTotalTaxe: sourceReception.montantTotalTaxe || 0,
            statut: sourceReception.statut || 'EN_ATTENTE',
            modeReglement: sourceReception.modeReglement || 'ESPECES',
            numeroCheque: sourceReception.numeroCheque,
            addresseLivraison: sourceReception.addresseLivraison || company.adresse,
            entrepotId: sourceReception.entrepotId || null,
            commandeNumero: sourceReception.commandeNumero || '',
            commandeId: sourceReception.commandeId || null,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fournisseurId: Yup.number().required(t('reception.supplierMissing', 'Supplier is required')),
            deliveryNoteNb: Yup.string().required(t('reception.deliveryNoteMissing', 'Delivery note number is required')),
            lignes: Yup.array().of(
                Yup.object().shape({
                    id: Yup.number(),
                    // prixUnitaireHT: Yup.number()
                    //     .min(1, t('reception.unitPriceMinValue', 'Unit price must be at least 1'))
                    //     .required(t('reception.unitPriceMissing', 'Unit price is required')),
                    quantiteRecue: Yup.number()
                        .moreThan(0, 'Indiquez une quantité supérieure à zéro.')
                        .required(t('reception.receivedQuantityMissing', 'Received quantity is required')),
                })
            ).min(1, t('reception.atLeastOneLine', 'At least one line is required')),
            entrepotId: Yup.number().required(t('reception.entrepotMissing', 'Entrepot is required')),
        }),


        onSubmit: (values) => {
            if (!validPurchaseQuantities(values.lignes, "quantiteRecue")) {
                Swal.fire({ icon: 'warning', text: 'La quantité gratuite doit être comprise entre zéro et la quantité globale, qui doit être positive.' });
                return;
            }
            if (!values.deliveryNoteNb) {
                Swal.fire({
                    icon: 'warning',
                    title: t('reception.missingDeliveryNoteTitle', 'Missing Delivery Note Number'),
                    text: t('reception.missingDeliveryNoteMessage', 'Please enter a delivery note number before submitting.'),
                    confirmButtonText: t('common.ok', 'OK')
                });
                return; // Stop the submission process
            }

            Swal.fire({
                title: 'Ajouter ces articles au stock ?',
                text: 'Les pièces gratuites seront rangées à part, sans être facturées.',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Oui, ajouter au stock',
                denyButtonText: 'Enregistrer pour plus tard',
                cancelButtonText: 'Continuer la saisie',
            }).then((result) => {
                if (result.isConfirmed) {
                    values.statut = 'VALIDE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (sourceReception.id) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: sourceReception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                } else if (result.isDenied) {
                    values.statut = 'EN_ATTENTE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            closeForm();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (sourceReception.id) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: sourceReception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                }
            });
        },
    });

    const { values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

    useEffect(() => {
        if (values.entrepotId || sourceReception.id) return;
        const choices = (entrepots || []).filter(item => ![item.code, item.libelle].some(value => String(value).toUpperCase() === 'FREE'));
        const preferred = choices.find(item => item.principal) || (choices.length === 1 ? choices[0] : null);
        if (preferred) setFieldValue('entrepotId', preferred.id);
    }, [entrepots, values.entrepotId, sourceReception.id, setFieldValue]);

    const handlePurchaseOrderChange = (selectedOption) => {
        if (selectedOption) {
            setFieldValue('commandeId', selectedOption.commandeId);
            setFieldValue('commandeNumero', selectedOption.value);
            setFieldValue('fournisseurId', selectedOption.fournisseurId);
            setFieldValue('fournisseurNom', selectedOption.fournisseurNom);
            setFieldValue('lignes', selectedOption.lignes.map(line => ({
                articleId: line.articleId,
                articleNom: line.articleNom,
                quantiteCommandee: line.quantiteCommandee,
                quantiteRecue: line.quantiteCommandee,
                quantiteGratuite: line.quantiteGratuite ?? 0,
                stockDisponible: line.stockDisponible,
                prixUnitaireHT: line.prixUnitaireHT,
                prixUnitaireTTC: line.prixUnitaireTTC,
                montantHT: line.montantHT,
                tauxTVA: line.tauxTVA,
                unite: line.unite,
                montantTTC: line.montantTTC
            })));

            setFieldValue('montantTotalHT', selectedOption.montantTotalHT);
            setFieldValue('montantTotalAvantRemise', selectedOption.montantTotalAvantRemise || selectedOption.montantTotalTTC);
            setFieldValue('montantRemise', selectedOption.montantRemise || 0);
            setFieldValue('modeRemise', selectedOption.modeRemise || 'MONTANT');
            setFieldValue('valeurRemise', selectedOption.valeurRemise ?? selectedOption.montantRemise ?? 0);
            setFieldValue('montantTotalTTC', selectedOption.montantTotalTTC);
            setFieldValue('montantTotalTaxe', selectedOption.montantTotalTaxe);
            setFieldValue('numeroCheque', selectedOption.numeroCheque);
            setFieldValue('modeReglement', selectedOption.modeReglement);
        } else {
            setFieldValue('montantTotalHT', 0);
            setFieldValue('montantTotalAvantRemise', 0);
            setFieldValue('montantRemise', 0);
            setFieldValue('valeurRemise', 0);
            setFieldValue('montantTotalTTC', 0);
            setFieldValue('montantTotalTaxe', 0);

            setFieldValue('commandeId', null);
            setFieldValue('commandeNumero', '');
            setFieldValue('fournisseurId', null);
            setFieldValue('numeroCheque', null);
            setFieldValue('modeReglement', null);
            setFieldValue('fournisseurNom', '');
            setFieldValue('lignes', []);
        }

    };

    const handleSupplierSubmit = () => {
        const newErrors = {};
        if (!supplierDisplayName(fournisseur).trim()) newErrors.name = 'Indiquez le nom du fournisseur.';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        let payload = {
            data: {
                ...fournisseur,
            },

            onSuccess: () => {
                Swal.fire({
                    icon: 'success',
                    title: 'Succès',
                    text: 'Fournisseur enregistré avec succès!',
                    confirmButtonText: 'OK',
                });

                setFournisseur({
                    nom: '',
                    prenom: '',
                    cin: '',
                    telephone1: '',
                    telephone2: '',
                    typeFournisseur: 'PARTICULIER',
                    email: '',
                    adresse: '',
                    ville: 'Casablanca',
                    codePostal: '',
                    plafond: 0,
                    entreprise: '',
                    ice: '',
                    solde: 0,
                    active: true,
                });

                setShowSupplierModal(false);
                setErrors({});
            },
        };


        dispatch(supplierActions.addSupplier(payload));

    };


    const handleFournisseurChange = (e) => {
        const { name, value } = e.target;
        setFournisseur((prev) => ({
            ...prev,
            [name]: name === 'active' ? value === 'true' : value, // Convert "true"/"false" to boolean for the active field
        }));
    };

    useEffect(() => {
        dispatch(entrepotActions.list());
    }, []);

    const handleCreateSupplier = () => {
        setShowSupplierModal(true);
    };

    const handleSupplierChange = async (selectedOption) => {
        if (selectedOption?.value === values.fournisseurId) return;
        if (values.lignes.length) {
            const choice = await Swal.fire({ title: 'Changer de fournisseur ?', text: 'Les articles choisis seront retirés de cette réception.', icon: 'question', showCancelButton: true, confirmButtonText: 'Changer de fournisseur', cancelButtonText: 'Garder ce fournisseur' });
            if (!choice.isConfirmed) return;
        }
        formik.setFieldValue('lignes', []); // Clear the lignes when the supplier changes
        formik.setFieldValue('fournisseurId', selectedOption?.value || null);
        formik.setFieldValue('fournisseurNom', selectedOption?.label || '');
        formik.setFieldValue('commandeId', null);
        formik.setFieldValue('commandeNumero', '');
        formik.setFieldValue('montantTotalTTC', 0);
        formik.setFieldValue('montantTotalHT', 0);
        formik.setFieldValue('montantTotalTaxe', 0);
        formik.setFieldValue('montantTotalAvantRemise', 0);
        formik.setFieldValue('montantRemise', 0);
        formik.setFieldValue('valeurRemise', 0);
    };




    const entrepotOptions = entrepots?.filter(entrepot => ![entrepot.code, entrepot.libelle].some(value => String(value).toUpperCase() === 'FREE')).map(entrepot => ({
        value: entrepot.id,
        label: entrepot.code + ' - ' + entrepot.libelle,
    })) ?? [];



    return (
    <Container fluid className="document-form-page simple-reception compact-receipt py-2">
        <Card className="document-form-card">
            <CardHeader className="document-form-header">
                <div className="document-form-title-row">
                    <div>
                        <h4 className="mb-1">
                            {sourceReception?.id ? `Réception ${sourceReception.numero || ''}` : 'Recevoir des marchandises'}
                        </h4>
                        <div className="text-muted">Choisissez les articles, indiquez les quantités, puis enregistrez.</div>
                    </div>
                    <div className="document-form-header-actions">
                        <Button type="button" color="light" className="document-form-return" onClick={closeForm}>
                            <FaArrowLeft className="me-2" />
                            {t('common.return')}
                        </Button>
                    </div>
                </div>
            </CardHeader>
            <CardBody className="document-form-body">
        <Form onSubmit={handleSubmit} className="document-form">
            <section className="document-form-section" aria-labelledby="receipt-step-one">
                <div className="receipt-step-title"><span>1</span><h2 id="receipt-step-one">D’où viennent les articles ?</h2></div>
                <Row className="g-2">
                    <Col md={6} xl={3}>
                        <FormGroup><Label for="receipt-supplier">Fournisseur</Label>
                            <Select inputId="receipt-supplier" name="supplier" placeholder="Choisir un fournisseur…"
                                options={fournisseurOptions} onChange={handleSupplierChange}
                                value={fournisseurOptions.find(option => option.value === values.fournisseurId) || null}
                                classNamePrefix="select" isDisabled={values.statut === 'VALIDE'}
                                noOptionsMessage={() => 'Aucun fournisseur trouvé'}
                                components={{ MenuList: ({ children, ...props }) => <components.MenuList {...props}>{children}
                                    <div className="border-top p-2"><Button type="button" color="light" block onClick={handleCreateSupplier}>+ Nouveau fournisseur</Button></div>
                                </components.MenuList> }} />
                            {touched.fournisseurId && formik.errors.fournisseurId && <div className="text-danger mt-1">Choisissez un fournisseur.</div>}
                        </FormGroup>
                    </Col>
                    <Col md={6} xl={3}>
                        <FormGroup><Label for="receipt-warehouse">Où ranger les articles ?</Label>
                            <Select inputId="receipt-warehouse" options={entrepotOptions}
                                value={entrepotOptions.find(option => option.value === values.entrepotId) || null}
                                onChange={option => setFieldValue('entrepotId', option?.value || null)}
                                placeholder="Choisir le lieu de stockage…" classNamePrefix="select" isDisabled={values.statut === 'VALIDE'} />
                            {touched.entrepotId && formik.errors.entrepotId && <div className="text-danger mt-1">Choisissez où ranger les articles.</div>}
                        </FormGroup>
                    </Col>
                    <Col md={6} xl={3}>
                        <FormGroup><Label for="receipt-date">Date de réception</Label><Input id="receipt-date" type="date" {...getFieldProps('dateReception')} disabled={values.statut === 'VALIDE'} /></FormGroup>
                    </Col>
                    <Col md={6} xl={3}>
                        <FormGroup><Label for="receipt-paper-number">Numéro du bon du fournisseur</Label>
                            <Input id="receipt-paper-number" type="text" {...getFieldProps('deliveryNoteNb')} placeholder="Le numéro écrit sur son bon de livraison" disabled={values.statut === 'VALIDE'} />
                            {touched.deliveryNoteNb && formik.errors.deliveryNoteNb && <div className="text-danger mt-1">Recopiez le numéro du bon de livraison.</div>}
                        </FormGroup>
                    </Col>
                </Row>
                <details className="receipt-optional">
                    <summary>Autres informations : commande, paiement…</summary>
                    <Row className="g-3">
                        <Col md={6}><FormGroup><Label for="receipt-order">Reprendre une commande (facultatif)</Label>
                            <Select inputId="receipt-order" isClearable options={poOptions} onChange={handlePurchaseOrderChange}
                                value={poOptions.find(option => option.value === values.commandeNumero) || (values.commandeNumero ? { value: values.commandeNumero, label: values.commandeNumero } : null)}
                                placeholder="Choisir une commande…" classNamePrefix="select" isDisabled={Boolean(sourceReception.id) || values.statut === 'VALIDE'} />
                        </FormGroup></Col>
                        <Col md={6}><FormGroup><Label for="receipt-operation-date">Date comptable</Label><Input id="receipt-operation-date" type="date" {...getFieldProps('dateOperation')} disabled={values.statut === 'VALIDE'} /></FormGroup></Col>
                        <Col md={6}><FormGroup><Label for="modeReglement">Mode de paiement</Label>
                            <Input id="modeReglement" type="select" {...getFieldProps('modeReglement')} disabled={values.statut === 'VALIDE'}>
                                <option value="ESPECES">Espèces</option><option value="CHEQUE">Chèque</option><option value="VIREMENT">Virement</option><option value="CARTE_BANCAIRE">Carte bancaire</option><option value="TRAITE">Traite</option>
                            </Input>
                        </FormGroup></Col>
                        {values.modeReglement === 'CHEQUE' && <Col md={6}><FormGroup><Label for="receipt-cheque">Numéro du chèque</Label><Input id="receipt-cheque" {...getFieldProps('numeroCheque')} value={values.numeroCheque || ''} disabled={values.statut === 'VALIDE'} /></FormGroup></Col>}
                    </Row>
                </details>
            </section>
            <section className="document-form-section document-form-lines-section">
                <div className="receipt-step-title"><span>2</span><h2>Quels articles avez-vous reçus ?</h2></div>
            <Row>
                <ReceptionLines formik={formik} />
                {formik.touched.lignes && formik.errors.lignes && (
                    <div className="invalid-feedback d-block">
                        {typeof formik.errors.lignes === 'string' ? formik.errors.lignes : 'Vérifiez les quantités des articles.'}
                    </div>
                )}
            </Row>
            </section>
            <section className="document-form-section receipt-checkout" aria-labelledby="receipt-step-three">
                <div className="receipt-step-title"><span>3</span><h2 id="receipt-step-three">Vérifiez et enregistrez</h2></div>
                <div className="receipt-checkout-total"><div><span>Total à payer au fournisseur</span><div className="text-muted">{values.lignes.length} article{values.lignes.length > 1 ? 's' : ''} · taxes comprises</div></div><strong>{formatPrice(values.montantTotalTTC)}</strong></div>
                <details className="receipt-optional mb-3">
                    <summary>{Number(values.montantRemise) > 0 ? `Réduction appliquée : ${formatPrice(values.montantRemise)}` : 'Le fournisseur vous fait une réduction ?'}</summary>
                    <PurchaseDiscount formik={formik} disabled={values.statut !== 'EN_ATTENTE'} />
                </details>
                <div className="receipt-checkout-actions"><Button type="submit" color="primary" disabled={values.statut !== 'EN_ATTENTE'}>Enregistrer la réception</Button><Button type="button" color="link" onClick={closeForm}>Retour</Button></div>
            </section>
        </Form>
            </CardBody>
        </Card>
        <Modal isOpen={showSupplierModal} toggle={() => setShowSupplierModal(false)} size="xl">
            <ModalHeader toggle={() => setShowSupplierModal(false)}>
                {t('supplier.new')}
            </ModalHeader>
            <ModalBody>
                    <SupplierInfoFields supplier={fournisseur} onChange={setFournisseur} errors={errors} />
                </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSupplierSubmit}>
                    {t('common.save')}
                </Button>
                <Button color="secondary" onClick={() => setShowSupplierModal(false)}>
                    {t('common.cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    </Container>
    );
};

export default ReceiptNoteNew;
